module.exports = __webpack_public_path__ + "media/images/registration/state_local_gov_contractor_user-2f53cc657430b804b341af2b12f22dd6.png";